__turbopack_context__.v({
  "list": "Nøkkeltall-module__wc_hpG__list",
});
